export class TranslateUtils {

    static buildTranslatePack = (translations: any[]): any => {
        let response = {};

        translations.forEach((translatePack) => {
            Object.assign(response, translatePack);
        });

        return response;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translate.utils.ts